import { render, staticRenderFns } from "./VentapMes.vue?vue&type=template&id=d1f5317c&"
import script from "./VentapMes.vue?vue&type=script&lang=js&"
export * from "./VentapMes.vue?vue&type=script&lang=js&"
import style0 from "./VentapMes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports